import React from "react";

export const Hide = props =>{
    return(
            <>
        {(!props.hide) && props.children}
                </>
    );
}